import { render, staticRenderFns } from "./EditInvoice.vue?vue&type=template&id=dfdeaaf4"
import script from "./EditInvoice.vue?vue&type=script&lang=js"
export * from "./EditInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports